import React from 'react'
import NumberInput from '../../../Components/PhoneInput/phoneInput'
import { ToastContainer } from 'react-toastify'
import UseAddContact from '../hooks/useAddContact'
import ValidationMessage from "../../ValidationMessage/validationMessage";
import Spinner from '../../../Components/spinner/spinner';

const AddContact = () => {
  const {
    navigate,
    addContact,
    spinner,
  } = UseAddContact()
  // const navigate = useNavigate()
  return (
    <section>
      <ToastContainer />
      <div className="m-t-3" >
        {spinner ? <Spinner /> : null}
        <h2 className="page-tittle">
          <i className="fa-solid fa-angle-left cusgap cursor" onClick={() => navigate(-1)} ></i>
          Add Contact
        </h2>
        <hr />

        <form className="cus-form row" onSubmit={addContact?.handleSubmit}>
          <div className="col-sm-6 mb-2">
            <label className="form-label">Name * </label>
            <input
              type="text"
              className="form-control"
              pattern="[A-Za-z ]*"
              title="Please enter only alphabetic characters"
              name='name'
              onChange={addContact.handleChange}
              value={addContact.values.name}
              maxLength={30}
            />
            <ValidationMessage formName={addContact} name={"name"} />
          </div>
          <div className="col-sm-6 mb-2">
            <label className="form-label">
              E-mail Address *
            </label>
            <input
              type="email"
              className="form-control"
              placeholder=""
              name="email"
              value={addContact.values.email}
              onChange={addContact.handleChange}
            />
            <ValidationMessage formName={addContact} name={"email"} />
          </div>
          <div className="col-sm-6 mb-2">
            <label className="form-label">Mobile Number * </label>
            <NumberInput
              width={false}
              Require={false}
              Name="mobileNo"
              HandleChange={addContact}
              Value={addContact.values.mobileNo}
            // extraFun={staffExist}
            />
            <ValidationMessage formName={addContact} name={"mobileNo"} />
          </div>


          <div className="d-grid  col-12  mb-3 justify-content-end">
            <button type="submit" className="btn colorbtun  px">
              Submit
            </button>
          </div>
        </form>
      </div>
    </section>
  )
}

export default AddContact